enum EmbeddedContentType {
    RawUrl,
    Youtube,
    Vimeo,
    VirtualTour
}

interface EmbeddedContent {
    Type: EmbeddedContentType;
    EmbedId: string;
}

export { EmbeddedContentType, EmbeddedContent }